import React, { useEffect, useState } from "react";
import GoOnDemandPractice2 from "./goOnDemandPractice2";
import "./goondemand.css";
import AllImg from "./images/all.png";
import CommunityImg from "./images/community.png";
import CSG from "./images/CSGnewone.png";
import PD from "./images/PDnew.png";
import groupNewImg from "./images/groupNewone.png";
import GroupImg from "./images/group.png";
import onDemandImg from "./images/on-demand.png";
import PracticeImg from "./images/practice.png";
import Speaker from "./images/speaker.png";
import { getOndemandCategories } from "../../../services/admin";
import GoOnDemandPractice1 from "./goOnDemandPractice1";
import { useSearchParams, useNavigate } from "react-router-dom";
import UpcomingPastEventPopup from "./upcomingPastEventPopup";
import { useTranslation } from "react-i18next";
import { useDynamicTranslation } from "../../../i18n/dynamicContent";

export default function GoOnDemandPractice() {
  const { t } = useTranslation("mediumPractice1");
  const { tc } = useDynamicTranslation();
  const [searchParams] = useSearchParams();
  const comingFrom = searchParams.get("to");
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const [showTabs, setShowTabs] = useState(true);
  const [session_id, setsession_id] = useState("");
  const [eventType, seteventType] = useState("Upcoming");

  useEffect(() => {
    sessionStorage.setItem("skip_auto_logout", "yes");

    if (comingFrom == "ondemand" || comingFrom == "groupcoaching" || comingFrom == "practicecircles" || comingFrom == "speakerEvents" || comingFrom == "coachedgroupcoaching" || comingFrom == "communitysupportgroups" || comingFrom =="allpracticecircles"|| comingFrom == "speakerEventsPast" || comingFrom == "platformDemonstration" || comingFrom == "professionalDemonstrations" || comingFrom == "platforGroupAll") {
      setShowTabs(false);
    } else if (!comingFrom) {
      // No ?to= param — redirect to Booking Hub instead of showing raw tiles grid
      navigate("/service-entry", { replace: true });
      return;
    }
    getOndemandCategories().then((data) => {
      console.log(data.data.data);
      let array = data.data.data;
      const newObject = { id: 0, sub_session_name: "Practice Circles" };
      array.splice(1, 0, newObject);

      setSessions(array);
      console.log(array, "array");
    });

    return () => {
      sessionStorage.removeItem("skip_auto_logout");
    };
  }, []);

  const setNewSessionId = (id) => {
    console.log("id", id);
    if (id == 95) {
      setsession_id(id);
      window.jQuery("#UpcomingPastEventPopup").modal("show");
    } else if (id === "public-transport") {
      setsession_id(101);
      setShowTabs(false);
    } else {
      setsession_id(id);
      setShowTabs(false);
    }
  };
  const onYesClick = () => {
    setShowTabs(false);
    seteventType("Upcoming");
  };
  const onNoClick = () => {
    setShowTabs(false);
    seteventType("Past");
  };

  const totalItems = sessions.length;
  const firstRowItems = sessions.slice(0, 3);
  const secondRowItems = sessions.slice(3, 6);
  const remainingItems = sessions.slice(6);
  const lastRowItems = [...remainingItems, { id: "all", sub_session_name: "All of the above" }];

  // Display-only labels: tiles this page adds itself use t(), API names go through tc().
  const displaySessionName = (item) =>
    item.id === 0
      ? t("sessionTypes.practiceCircles")
      : item.id === "all"
      ? t("sessionTypes.allOfTheAbove")
      : tc(item.sub_session_name);

  return (
    <>
      {showTabs ? (
        <div className="container-fluid ">
          <div className="dashboard ">
            <div className="row">
              <div className="col-md-12">
                <div className="quck-box">
                  <h2>{t("sessionTypes.selectHeading")}</h2>

                  {/* First Row - 3 items */}
                  <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes">
                    {firstRowItems.map((item) => (
                      <div
                        onClick={() => setNewSessionId(item.id)}
                        className="upcoming-comlilated pointer"
                        key={item.id}
                      >
                        <div className="content-left">
                          <div className={`icon-left ${item.id == 91 ? "CSG" : item.id == 0 ? "Speaker" : item.id == 101 ? "AllImg" : item.id == 99 ? "GroupImg" : "GroupImgNew"}`}>
                            <img
                              src={
                                item.id == 91
                                  ? onDemandImg
                                  : item.id == 0
                                  ? CommunityImg
                                  : groupNewImg
                              }
                              alt="count"
                            />
                          </div>
                          <span>{displaySessionName(item)}</span>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes">
                    {secondRowItems.map((item) => (
                      <div
                        onClick={() => setNewSessionId(item.id)}
                        className="upcoming-comlilated pointer"
                        key={item.id}
                      >
                        <div className="content-left">
                          <div className={`icon-left ${item.id == 96 ? "CSG" : item.id == 95 ? "Speaker" : item.id == 101 ? "AllImg" : item.id == 99 ? "GroupImg" : "AllImg"}`}>
                            <img
                              src={
                                item.id == 96
                                  ? CSG
                                  : item.id == 95
                                  ? Speaker
                                  : item.id == 101
                                  ? AllImg
                                  : item.id == 99
                                  ? GroupImg
                                  : AllImg
                              }
                              alt="count"
                            />
                          </div>
                          <span>{displaySessionName(item)}</span>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="quick-status-two admin-dashboard-page go-ondemand-practice-boxes">
                    {lastRowItems.map((item) => (
                      <div
                        onClick={() => setNewSessionId(item.id)}
                        className="upcoming-comlilated pointer"
                        key={item.id}
                      >
                        <div className="content-left">
                          <div className={`icon-left ${item.id === "all" ? "AllImg" : item.id == 96 ? "CSG" : item.id == 95 ? "Speaker" : item.id == 101 ? "PD" : "AllImg"}`}>
                            <img
                              src={
                                item.id === "all"
                                  ? AllImg
                                  : item.id == 96
                                  ? CommunityImg
                                  : item.id == 95
                                  ? Speaker
                                  : item.id == 101
                                  ? PD
                                  : AllImg
                              }
                              alt="count"
                            />
                          </div>
                          <span>{displaySessionName(item)}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <GoOnDemandPractice1
          setSessions={setSessions}
          sessions={sessions}
          session_id={session_id}
          setsession_id={setsession_id}
          seteventType={seteventType}
          eventType={eventType}
        />
      )}
      <UpcomingPastEventPopup onYesClick={onYesClick} onNoClick={onNoClick} />
    </>
  );
}
